import React from "react";

const Info = () => {
  return (
    <div className="text-text dark:text-darktext">
     
      <div className="w-full sm:w-4/5 mx-auto py-8 px-4">
        <h2 className="sm:text-4xl text-3xl font-bold text-center mb-6">¿Qué Incluye?</h2>
        
        <div className="grid lg:grid-cols-3 gap-8">
          <div className="border-2 p-6 rounded-xl bg-pagebackground dark:bg-darkpagebackground border-accent dark:border-darkaccent sm:border-x-2 text-center">
            <h3 className="text-xl xl:text-2xl font-semibold mb-4 text-balance">Listas de Números Disponibles</h3>
            <p className="text-base xl:text-lg text-balance mb-4">
              Múltiples Listas para cada Línea. 
              </p>
              <p className="mb-4">
              Ejemplo: 
              <a href="https://lineaselflaco.com/lineas/1mil" target="_blank" rel="noopener noreferrer" className="text-green-600 dark:text-green-400 underline"> lineaselflaco.com/lineas/1mil</a>
              </p>
            <a href="https://lineaselflaco.com/lineas/1mil" target="_blank" rel="noopener noreferrer" className="text-white bg-green-600 dark:bg-green-700 px-4 py-2 rounded-lg hover:bg-green-700 dark:hover:bg-green-600 transition">
              Ver Ejemplo
            </a>
          </div>
          
          <div className="border-2 p-6  rounded-xl bg-pagebackground dark:bg-darkpagebackground border-accent dark:border-darkaccent sm:border-x-2 text-center">
            <h3 className="text-xl xl:text-2xl  font-semibold mb-4">Boleto Digital</h3>
            <p className="text-base xl:text-lg text-balance mb-4">
              Genera y visualiza boletos digitales.
              </p>
              <p className="mb-4">
              Ejemplo: 
              <a href="https://lineaselflaco.com/boleto-digital" target="_blank" rel="noopener noreferrer" className="text-green-600 dark:text-green-400 underline"> lineaselflaco.com/boleto-digital</a>
            </p>
            <a href="https://lineaselflaco.com/boleto-digital" target="_blank" rel="noopener noreferrer" className="text-white bg-green-600 dark:bg-green-700 px-4 py-2 rounded-lg hover:bg-green-700 dark:hover:bg-green-600 transition">
              Ver Ejemplo
            </a>
          </div>
          
          <div className="border-2 p-6  rounded-xl bg-pagebackground dark:bg-darkpagebackground border-accent dark:border-darkaccent sm:border-x-2 text-center">
            <h3 className="text-xl xl:text-2xl font-semibold mb-4">Verificador de Boletos</h3>
            <p className="text-base xl:text-lg text-balance mb-4">
              Comprueba el estatus de los boletos.
              </p>
              <p className="mb-4">
                Ejemplo:
              <a href="https://lineaselflaco.com/verificador" target="_blank" rel="noopener noreferrer" className="text-green-600 dark:text-green-400 underline"> lineaselflaco.com/verificador</a>
            </p>
            <a href="https://lineaselflaco.com/verificador"   target="_blank" rel="noopener noreferrer" className="text-white bg-green-600 dark:bg-green-700 px-4 py-2 rounded-lg hover:bg-green-700 dark:hover:bg-green-600 transition">
              Ver Ejemplo
            </a>
          </div>

          
        </div>
      </div>

      <div className="w-full sm:w-4/5 mx-auto px-4 ">
      <div className="border-2 p-6  rounded-xl bg-pagebackground dark:bg-darkpagebackground border-accent dark:border-darkaccent sm:border-x-2 text-center">
        <div className=" mx-auto text-center">
          <h2 className="text-xl xl:text-2xl  font-semibold mb-4">Panel de Control</h2>
          <p className="text-base xl:text-lg text-balance mb-4">
            Administra todos tus boletos, confirma pagos, envía boletos, libera números para venta y más, todo desde un solo lugar.
          </p>
          
        </div>
      </div>
      </div>


      
    </div>
  );
};

export default Info;
